import { Paragraph } from '@almbrand/paragraph';
import { SystemIcons } from '@almbrand/systemicons';
import { BasketThemeName } from '../Basket.types';
import { BasketTile } from '../BasketTile';
import styles from './ExistingCustomerCard.module.scss';

export interface ExistingCustomerCardProps {
	themeName: BasketThemeName;
	onClick?: () => void;
	ariaLabel?: string;
	element?: 'li' | 'article'; // use 'li' when rendered inside list and 'article' if rendered stand-alone
	text?: {
		title?: string;
		subtitle?: string;
	};
}

export type ExistingCustomerCardText = NonNullable<ExistingCustomerCardProps['text']>;

export const ExistingCustomerCard: React.FC<ExistingCustomerCardProps> = ({
	themeName,
	onClick,
	ariaLabel,
	element,
	text: { title, subtitle } = {},
}) => {
	return (
		<BasketTile
			element={element}
			onClick={onClick}
			ariaLabel={ariaLabel}
		>
			<div className={styles.ExistingCustomerCard}>
				<div className={styles.ExistingCustomerCard__text}>
					<Paragraph
						className={styles.ExistingCustomerCard__title}
						text={title}
						paragraphType={{ kind: 'title', type: 'standfirst' }}
						fontColor='primary'
					/>
					<Paragraph
						className={styles.ExistingCustomerCard__subtitle}
						text={subtitle}
						paragraphType={{ kind: 'label', size: 'default' }}
						fontColor='primaryDark'
					/>
				</div>

				<div
					className={styles.ExistingCustomerCard__iconContainer}
					aria-hidden='true'
				>
					<SystemIcons
						themeName={themeName}
						icon='mit_id'
						width={32}
						height={32}
						fill='var(--color-primary-1)'
					/>
				</div>
			</div>
		</BasketTile>
	);
};
